import React from 'react'
import styled from '@emotion/styled'

import {cssTheme} from '@vio/atlas/themes'
import {useInView} from '@vio/core/src/_web/utils/browser/hooks/useInView'

import {HEADER_HEIGHT} from '../styles'

interface Props {
  months: string[]
  isCheckInMonth: boolean
  checkInMonthRef?: React.MutableRefObject<HTMLDivElement | null>
  date: Date
  onInView?: (date: Date) => void
}

const CaptionElement = styled.div`
  ${cssTheme.typography.titleM};
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  height: ${HEADER_HEIGHT}px;
  .--is-vertical & {
    padding-top: ${cssTheme.layout.spacing.s500};
    padding-bottom: ${cssTheme.layout.spacing.s200};
    padding-left: ${cssTheme.layout.spacing.s300};
    padding-right: ${cssTheme.layout.spacing.s300};
    display: block;
    height: auto;
  }
`

export const MonthName = ({
  months,
  isCheckInMonth,
  checkInMonthRef,
  date,
  onInView
}: Props) => {
  const {ref: monthRef, inView: isMonthInView} = useInView()

  if (isMonthInView) {
    onInView?.(date)
  }

  return (
    <CaptionElement
      {...(isCheckInMonth ? {ref: checkInMonthRef} : {ref: monthRef})}
    >
      {months && `${months[date.getMonth()]} ${date.getFullYear()}`}
    </CaptionElement>
  )
}
